import {
	RemoteConfigurationEngineConfigs,
	RemoteConfigurationEnginesOperationalConfigs,
} from '@bcp-nextgen-dx-touchpoint-framework/react-js';

const remoteConfigurationEngineConfigs: RemoteConfigurationEngineConfigs<RemoteConfigurationEnginesOperationalConfigs> =
	{
		enginesOperationalConfigurations: {
			channelTouchPoint: {
				channelTouchPointType: 'App',
				channelTouchPointName: 'TouchPoint1Site',
			},
			authenticationAndAuthorizationEngine: {},
			globalEnginesConfigurations: {
				artifactTimeToLiveSeconds: '200',
				operationalConfigsTimeToLiveSeconds: '200',
				logLevel: 'ERROR',
			},
			communicationEngine: {
				artifactTimeToLiveSeconds: '400',
			},
			connectivityEngine: {},
			cryptographyEngine: {},
			deviceListenerEngine: {},
			enginesCatalog: {},
			interactionEngine: {},
			journeyEngine: {
				journeyArtifactTimeToLiveSeconds: '300',
			},
			loggingAndExceptionHandlingEngine: {
				// Logging
				applicationalLogsTimeToShip: '60',
				applicationalLogsSizeToShip: '150',
			},
			mediaAndCameraEngine: {
				//cacheOperationConfig
			},
			personalizationEngine: {
				operationalConfigsTimeToLiveSeconds: '500',
				personalizationArtifactTimeToLiveSeconds: '200',
			},
			prismEngine: {},
			reduxStateEngine: {},
			remoteConfigurationEngine: {
				operationalConfigsArtifactTimeToLiveSeconds: '150',
			},
			templateEngine: {
				configurationArtifactTimeToLiveSeconds: '300',
			},
		},
	};

export default remoteConfigurationEngineConfigs;
